import { IConnectionStrategy } from './IConnectionStrategy';

export class FixedDelayStrategy implements IConnectionStrategy {
  constructor(private readonly delayMs: number) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getReconnectDelay(_retries: number): number {
    return this.delayMs;
  }

  reset(): void {
    // No state to reset for fixed delay
  }
}
